export default __webpack_public_path__ + "static/media/Delivery.54692048.webp";